module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "cc-progress"
  }, [_c('div', {
    staticClass: "cc-progress-bar",
    class: {
      'cc-progress-bar-active': _vm.isActiveCall
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60% Complete")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "height": "calc(100% - 5px)"
    }
  }, [(!_vm.isloggedIn) ? _c('cc-login', {
    on: {
      "logout": _vm.onLogin
    }
  }) : _c('div', {
    staticClass: "row ",
    attrs: {
      "id": "cc-maske"
    }
  }, [_c('div', {
    staticClass: "col-xs-7",
    attrs: {
      "id": "cc-left"
    }
  }, [_c('company-callcenter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isActiveCall),
      expression: "!isActiveCall"
    }],
    staticClass: "cc-box",
    attrs: {
      "id": "company-callcenter"
    }
  }), _vm._v(" "), _c('company-client', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActiveCall),
      expression: "isActiveCall"
    }],
    staticClass: "cc-box",
    attrs: {
      "id": "company-client"
    }
  }), _vm._v(" "), _c('user-callcenter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isActiveCall),
      expression: "!isActiveCall"
    }],
    staticClass: "cc-box",
    attrs: {
      "id": "user-callcenter"
    },
    on: {
      "logout": _vm.onClickLogout
    }
  }), _vm._v(" "), _c('user-client', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActiveCall),
      expression: "isActiveCall"
    }],
    staticClass: "cc-box",
    attrs: {
      "id": "user-client"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5",
    attrs: {
      "id": "cc-right"
    }
  }, [_c('user-caller', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActiveCall),
      expression: "isActiveCall"
    }],
    staticClass: "cc-box",
    attrs: {
      "id": "user-caller"
    }
  }), _vm._v(" "), (!_vm.isActiveCall) ? _c('parking', {
    staticClass: "cc-box",
    attrs: {
      "id": "parking"
    }
  }) : _vm._e(), _vm._v(" "), _c('message', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "cc-box",
    attrs: {
      "id": "message"
    }
  }), _vm._v(" "), _c('history', {
    staticClass: "cc-box",
    attrs: {
      "id": "cc-history"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf03c0e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 291
// module chunks = 0